// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Error Monitor – modern admin styling (scoped with .em-*) */

:root {
  --em-primary: #3B82F6;
  --em-danger: #EF4444;
  --em-warning: #F59E0B;
  --em-success: #10B981;
  --em-bg: #F9FAFB;
  --em-card: #FFFFFF;
  --em-text: #0F172A;
  --em-muted: #000;
  --em-border: rgba(15, 23, 42, 0.10);
  --em-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);
  --em-shadow-soft: 0 6px 18px rgba(15, 23, 42, 0.06);
  --em-radius: 14px;
}

.em-page {
  border-radius: var(--em-radius);
  padding: 18px;
}

.em-bold {
  font-size: 1.2rem;
  font-weight: bold;
}

.em-page--dark {
  background:
    radial-gradient(1200px 400px at 10% 0%, rgba(59, 130, 246, 0.16), transparent 60%),
    radial-gradient(900px 360px at 90% 10%, rgba(16, 185, 129, 0.12), transparent 55%),
    #020617;
  color: #e5e7eb;
}

.em-page--dark .em-title {
  color: #f9fafb;
}

.em-page--dark .em-subtitle {
  color: #9ca3af;
}

.em-page--dark .em-card,
.em-page--dark .em-panel,
.em-page--dark .em-tableWrap,
.em-page--dark .em-ana-card,
.em-page--dark .em-chart-box {
  background: #020617;
  border-color: rgba(148, 163, 184, 0.5);
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.9);
}

.em-text-primary {
  color: var(--em-primary);
  font-weight: bold;
  font-size: medium;
  text-transform: capitalize;
}

.em-page--dark .em-ana-card__icon {
  background: rgba(15, 23, 42, 0.9);
}

.em-page--dark .em-analysis,
.em-page--dark .em-ana-card__label,
.em-page--dark .em-ana-card__value,
.em-page--dark .em-muted {
  color: #e5e7eb;
}

.em-page--dark .em-table thead th {
  background: #020617;
  border-bottom-color: rgba(148, 163, 184, 0.5);
  color: #9ca3af;
}

.em-page--dark .em-table tbody td {
  color: #e5e7eb;
  border-bottom-color: rgba(15, 23, 42, 0.9);
}

.em-page--dark .em-table tbody tr:nth-child(odd) td {
  background: rgba(15, 23, 42, 0.5);
}

.em-page--dark .em-table tbody tr:hover td {
  background: rgba(59, 130, 246, 0.25);
}

.em-page--dark .em-btn {
  background: #020617;
  color: #e5e7eb;
  border-color: rgba(148, 163, 184, 0.6);
}

.em-page--dark .em-btn:hover {
  background: rgba(59, 130, 246, 0.45);
  border-color: rgba(59, 130, 246, 0.8);
}

.em-page--dark .em-ana-card--critical {
  background: rgba(239, 68, 68, 0.12);
}

/* Login layout */
.em-login {
  min-height: 100vh;
  background:
    radial-gradient(1200px 400px at 0% 0%, rgba(59, 130, 246, 0.10), transparent 60%),
    radial-gradient(900px 360px at 100% 0%, rgba(16, 185, 129, 0.08), transparent 55%),
    var(--em-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.em-login__shell {
  width: 100%;
  max-width: 1040px;
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2.6fr);
  gap: 24px;
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.10);
  padding: 22px 22px 22px 26px;
}

.em-login__aside {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  color: var(--em-text);
  border-right: 1px solid rgba(148, 163, 184, 0.3);
  padding-right: 18px;
}

.em-login__logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.em-login__logoIcon {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(37, 99, 235, 0.18);
  color: #60a5fa;
}

.em-login__logoText {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.em-login__logoTitle {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--em-text);
}

.em-login__logoSub {
  font-size: 1.2rem;
  color: var(--em-muted);
}

.em-login__hero h2 {
  margin: 0 0 8px;
  font-size: 2.1rem;
  font-weight: 700;
  color: var(--em-text);
}

.em-login__hero p {
  margin: 0 0 14px;
  font-size: 1.35rem;
  color: var(--em-muted);
}

.em-login__heroMeta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 1.2rem;
  color: var(--em-text);
}

.em-login__heroMeta > div {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(59, 130, 246, 0.04);
  border: 1px solid rgba(148, 163, 184, 0.4);
}

.em-login__card {
  background: #ffffff;
  border-radius: 18px;
  padding: 20px 22px;
  border: 1px solid rgba(148, 163, 184, 0.5);
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.12);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.em-login__cardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.em-login__cardHeader .em-title {
  color: var(--em-text);
}

.em-login__cardHeader .em-subtitle {
  color: var(--em-muted);
}

@media (max-width: 900px) {
  .em-login__shell {
    grid-template-columns: minmax(0, 1fr);
    padding: 20px 18px;
  }
  .em-login__aside {
    border-right: none;
    border-bottom: 1px solid rgba(148, 163, 184, 0.3);
    padding-right: 0;
    padding-bottom: 18px;
  }
}

@media (max-width: 600px) {
  .em-login {
    padding: 16px 12px;
  }
}

.em-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 14px;
}

.em-title {
  margin: 0;
  color: var(--em-text);
  /* letter-spacing: -0.02em; */
}

.em-subtitle {
  margin: 4px 0 0;
  color: var(--em-muted);
  font-size: 1.4rem;
}

.em-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 12px;
  margin-bottom: 14px;
}

.em-card {
  grid-column: span 3;
  background: var(--em-card);
  border: 1px solid var(--em-border);
  border-radius: var(--em-radius);
  box-shadow: var(--em-shadow-soft);
  padding: 14px 14px;
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}

.em-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--em-shadow);
  border-color: rgba(59, 130, 246, 0.20);
}

.em-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.em-card__label {
  color: var(--em-muted);
  font-size: 1.2rem;
  text-transform: uppercase;
  letter-spacing: .08em;
}

.em-card__value {
  margin-top: 6px;
  font-size: 2.4rem;
  font-weight: 800;
  color: var(--em-text);
  letter-spacing: -0.02em;
}

.em-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(59, 130, 246, 0.12);
  color: var(--em-primary);
  flex: 0 0 auto;
}

.em-icon--danger {
  background: rgba(239, 68, 68, 0.12);
  color: var(--em-danger);
}

.em-icon--warning {
  background: rgba(245, 158, 11, 0.12);
  color: var(--em-warning);
}

.em-icon--success {
  background: rgba(16, 185, 129, 0.12);
  color: var(--em-success);
}

.em-panel {
  background: var(--em-card);
  border: 1px solid var(--em-border);
  border-radius: var(--em-radius);
  box-shadow: var(--em-shadow-soft);
  padding: 14px;
}

/* Sticky toolbar (Error analysis + Live updates + Refresh) */
.em-toolbar {
  position: sticky;
  top: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  margin: 6px -6px 16px;
  background: linear-gradient(to bottom, rgba(249, 250, 251, 0.96), rgba(249, 250, 251, 0.9));
  backdrop-filter: blur(8px);
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.35);
}

.em-toolbar__left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.em-toolbar__title {
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--em-text);
}

.em-toolbar__badge {
  font-size: 1.1rem;
  padding: 3px 9px;
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.08);
  color: var(--em-success);
  border: 1px solid rgba(16, 185, 129, 0.25);
}

.em-toolbar__right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.em-spinner {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  border: 2px solid rgba(148, 163, 184, 0.5);
  border-top-color: var(--em-primary);
  animation: em-spin 0.8s linear infinite;
}

@keyframes em-spin {
  to {
    transform: rotate(360deg);
  }
}

.em-filters {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  gap: 10px;
  align-items: end;
}

.em-field label {
  display: block;
  font-size: 1.2rem;
  color: var(--em-muted);
  margin-bottom: 6px;
}

.em-input {
  width: 100%;
  border: 1px solid var(--em-border);
  border-radius: 12px;
  padding: 10px 12px;
  background: #fff;
  outline: none;
  transition: box-shadow .18s ease, border-color .18s ease;
  min-height: 44px;
}

.em-input:focus {
  border-color: rgba(59, 130, 246, 0.45);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);
}

/* Better-looking dropdowns */
.em-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-right: 40px;
  cursor: pointer;
  background-image:
    linear-gradient(45deg, transparent 50%, rgba(100, 116, 139, 0.95) 50%),
    linear-gradient(135deg, rgba(100, 116, 139, 0.95) 50%, transparent 50%),
    linear-gradient(to right, transparent, transparent);
  background-position:
    calc(100% - 18px) 18px,
    calc(100% - 13px) 18px,
    0 0;
  background-size: 6px 6px, 6px 6px, 100% 100%;
  background-repeat: no-repeat;
}

.em-select:hover {
  border-color: rgba(59, 130, 246, 0.30);
}

.em-select:disabled {
  cursor: not-allowed;
  opacity: 0.7;
  background-image: none;
}

.em-tableWrap {
  background: var(--em-card);
  border: 1px solid var(--em-border);
  border-radius: var(--em-radius);
  box-shadow: var(--em-shadow-soft);
  overflow: hidden;
}

.em-tableScroll {
  overflow-x: auto;
  overflow-y: visible;
}

.em-tableScroll::-webkit-scrollbar {
  height: 5px;
  width: 0;
  display: block;
}

.em-tableScroll::-webkit-scrollbar-track {
  background: transparent;
}

.em-tableScroll::-webkit-scrollbar-thumb {
  background: rgba(15, 23, 42, 0.1);
  border-radius: 10px;
}

.em-tableScroll::-webkit-scrollbar-thumb:hover {
  background: rgba(15, 23, 42, 0.2);
}


.em-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 980px;
}

.em-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
  border-bottom: 1px solid var(--em-border);
  color: var(--em-muted);
  font-size: 1.2rem;
  letter-spacing: .08em;
  text-transform: uppercase;
  padding: 12px 14px;
  cursor: pointer;
  user-select: none;
}

.em-table tbody td {
  padding: 12px 14px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  vertical-align: middle;
  color: var(--em-text);
  font-size: 1.2rem;
}

.em-table tbody tr:nth-child(odd) td {
  background: rgba(15, 23, 42, 0.015);
}

.em-table tbody tr:hover td {
  background: rgba(59, 130, 246, 0.06);
}

.em-vendor {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.em-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 1.2rem;
  letter-spacing: .02em;
  border: 1px solid transparent;
  white-space: nowrap;
}

.em-badge--high {
  background: rgba(239, 68, 68, 0.12);
  color: var(--em-danger);
  border-color: rgba(239, 68, 68, 0.24);
}

.em-badge--medium {
  background: rgba(245, 158, 11, 0.14);
  color: var(--em-warning);
  border-color: rgba(245, 158, 11, 0.26);
}

.em-badge--low {
  background: rgba(16, 185, 129, 0.14);
  color: var(--em-success);
  border-color: rgba(16, 185, 129, 0.26);
}

.em-badge--status {
  background: rgba(59, 130, 246, 0.10);
  color: var(--em-primary);
  border-color: rgba(59, 130, 246, 0.22);
}

.em-actions {
  display: inline-flex;
  /* gap: 8px;
  flex-wrap: wrap; */
}

.em-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 999px;
  padding: 7px 10px;
  font-size: 1.2rem;
  font-weight: 700;
  border: 1px solid var(--em-border);
  background: #fff;
  color: var(--em-text);
  cursor: pointer;
  transition: transform .12s ease, background .12s ease, border-color .12s ease;
}

.em-btn:hover {
  transform: translateY(-1px);
  background: rgba(59, 130, 246, 0.06);
  border-color: rgba(59, 130, 246, 0.30);
}

.em-btn--primary {
  background: rgba(59, 130, 246, 0.12);
  color: var(--em-primary);
  border-color: rgba(59, 130, 246, 0.28);
}

.em-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
}

.em-muted {
  color: var(--em-muted);
}

.em-modalTitle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.em-json {
  font-family: var(--hw-font-monospace);
  white-space: pre;
}

/* Markdown / answer rendering (ChatGPT-like) */
.em-markdown {
  font-size: 1.4rem;
  line-height: 1.7;
  color: var(--em-text);
}

.em-markdown h1,
.em-markdown h2,
.em-markdown h3,
.em-markdown h4,
.em-markdown h5,
.em-markdown h6 {
  margin: 1.2em 0 0.4em;
  font-weight: 700;
}

.em-markdown p {
  margin: 0.6em 0;
}

.em-markdown ul,
.em-markdown ol {
  margin: 0.6em 0 0.6em 1.6em;
  padding-left: 1em;
}

.em-markdown li {
  margin: 0.2em 0;
}

.em-markdown code {
  font-family: var(--hw-font-monospace);
  background: rgba(15, 23, 42, 0.04);
  padding: 0.1em 0.35em;
  border-radius: 4px;
  font-size: 1.3rem;
}

.em-markdown pre code {
  background: transparent;
  padding: 0;
}

.em-markdown pre {
  font-family: var(--hw-font-monospace);
  background: #0f172a;
  color: #e5e7eb;
  padding: 1.2em 1.4em;
  border-radius: 10px;
  margin: 1em 0;
  overflow-x: auto;
  font-size: 1.3rem;
}

.em-markdown table {
  width: 100%;
  border-collapse: collapse;
  margin: 0.8em 0;
  font-size: 1.3rem;
}

.em-markdown table th,
.em-markdown table td {
  border: 1px solid var(--em-border);
  padding: 0.5em 0.75em;
}

.em-markdown table th {
  background: rgba(15, 23, 42, 0.03);
  text-align: left;
  font-weight: 600;
}

/* Horizontal scroll indicator for mobile */
.em-scrollHint {
  display: none;
  padding: 8px 14px;
  font-size: 1.1rem;
  color: var(--em-muted);
  background: rgba(15, 23, 42, 0.02);
  border-bottom: 1px solid var(--em-border);
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-weight: 500;
}

@media (max-width: 980px) {
  .em-scrollHint {
    display: flex;
  }
}

@media (max-width: 1100px) {
  .em-card {
    grid-column: span 6;
  }

  .em-filters {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 600px) {
  .em-card {
    grid-column: span 12;
  }

  .em-page {
    padding: 12px;
  }
}

/* Error Analysis Section */
.em-analysis {
  margin: 32px 0;
}

.em-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--em-border);
}

.em-analysis-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.em-ana-card {
  background: var(--em-card);
  border: 1px solid var(--em-border);
  border-radius: 14px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: var(--em-shadow-soft);
  transition: transform 0.2s ease;
}

.em-ana-card:hover {
  transform: translateY(-2px);
}

.em-ana-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  color: var(--em-primary);
  flex-shrink: 0;
}

.em-ana-card__info {
  display: flex;
  flex-direction: column;
}

.em-ana-card__label {
  font-size: 1rem;
  color: var(--em-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
}

.em-ana-card__value {
  font-size: 2.2rem;
  font-weight: 800;
  color: var(--em-text);
  line-height: 1.2;
}

.em-ana-card--critical {
  border-color: rgba(239, 68, 68, 0.2);
  background: rgba(239, 68, 68, 0.02);
}

.em-ana-card--critical .em-ana-card__icon {
  background: rgba(239, 68, 68, 0.1);
  color: var(--em-danger);
}

.em-charts-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.em-chart-box {
  background: var(--em-card);
  border: 1px solid var(--em-border);
  border-radius: var(--em-radius);
  padding: 24px;
  box-shadow: var(--em-shadow-soft);
}

.em-chart-box--full {
  grid-column: span 2;
}

.em-chart-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--em-text);
  margin-bottom: 24px;
  letter-spacing: -0.01em;
}

.em-chart-container {
  width: 100%;
}

@media (max-width: 1300px) {
  .em-analysis-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1100px) {
  .em-charts-row {
    grid-template-columns: 1fr;
  }

  .em-chart-box--full {
    grid-column: span 1;
  }
}

@media (max-width: 768px) {
  .em-analysis-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 600px) {
  .em-analysis-grid {
    grid-template-columns: 1fr;
  }
}
.em-markdown pre {
  background: #0d1117;
  padding: 16px;
  border-radius: 8px;
  overflow-x: auto;
}

.em-markdown code {
  font-size: 13px;
}

.em-markdown h3 {
  margin-top: 24px;
}

.generated-fix-panel{
  background: rgba(59, 130, 246, 0.12);
  color: var(--em-primary);
  border-color: rgba(59, 130, 246, 0.28);
  margin-top: 10px;
}
.em-btn-active{
  transform: translateY(-1px);
  background: rgba(59, 130, 246, 0.06);
  border-color: rgba(59, 130, 246, 0.30);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/errorMonitor.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,+CAA+C;EAC/C,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;;;WAGS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,mBAAmB;EACnB,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB;;;gBAGc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;IACrC,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,iDAAiD;IACjD,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,iCAAiC;EACjC,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,iCAAiC;EACjC,aAAa;AACf;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,2FAA2F;EAC3F,0BAA0B;EAC1B,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf;;;uDAGqD;EACrD;;;OAGK;EACL,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;;AAGA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB;oBACkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;;;EAME,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kCAAkC;EAClC,yCAAyC;EACzC,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,sCAAsC;AACxC","sourcesContent":["/* Error Monitor – modern admin styling (scoped with .em-*) */\n\n:root {\n  --em-primary: #3B82F6;\n  --em-danger: #EF4444;\n  --em-warning: #F59E0B;\n  --em-success: #10B981;\n  --em-bg: #F9FAFB;\n  --em-card: #FFFFFF;\n  --em-text: #0F172A;\n  --em-muted: #000;\n  --em-border: rgba(15, 23, 42, 0.10);\n  --em-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);\n  --em-shadow-soft: 0 6px 18px rgba(15, 23, 42, 0.06);\n  --em-radius: 14px;\n}\n\n.em-page {\n  border-radius: var(--em-radius);\n  padding: 18px;\n}\n\n.em-bold {\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.em-page--dark {\n  background:\n    radial-gradient(1200px 400px at 10% 0%, rgba(59, 130, 246, 0.16), transparent 60%),\n    radial-gradient(900px 360px at 90% 10%, rgba(16, 185, 129, 0.12), transparent 55%),\n    #020617;\n  color: #e5e7eb;\n}\n\n.em-page--dark .em-title {\n  color: #f9fafb;\n}\n\n.em-page--dark .em-subtitle {\n  color: #9ca3af;\n}\n\n.em-page--dark .em-card,\n.em-page--dark .em-panel,\n.em-page--dark .em-tableWrap,\n.em-page--dark .em-ana-card,\n.em-page--dark .em-chart-box {\n  background: #020617;\n  border-color: rgba(148, 163, 184, 0.5);\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.9);\n}\n\n.em-text-primary {\n  color: var(--em-primary);\n  font-weight: bold;\n  font-size: medium;\n  text-transform: capitalize;\n}\n\n.em-page--dark .em-ana-card__icon {\n  background: rgba(15, 23, 42, 0.9);\n}\n\n.em-page--dark .em-analysis,\n.em-page--dark .em-ana-card__label,\n.em-page--dark .em-ana-card__value,\n.em-page--dark .em-muted {\n  color: #e5e7eb;\n}\n\n.em-page--dark .em-table thead th {\n  background: #020617;\n  border-bottom-color: rgba(148, 163, 184, 0.5);\n  color: #9ca3af;\n}\n\n.em-page--dark .em-table tbody td {\n  color: #e5e7eb;\n  border-bottom-color: rgba(15, 23, 42, 0.9);\n}\n\n.em-page--dark .em-table tbody tr:nth-child(odd) td {\n  background: rgba(15, 23, 42, 0.5);\n}\n\n.em-page--dark .em-table tbody tr:hover td {\n  background: rgba(59, 130, 246, 0.25);\n}\n\n.em-page--dark .em-btn {\n  background: #020617;\n  color: #e5e7eb;\n  border-color: rgba(148, 163, 184, 0.6);\n}\n\n.em-page--dark .em-btn:hover {\n  background: rgba(59, 130, 246, 0.45);\n  border-color: rgba(59, 130, 246, 0.8);\n}\n\n.em-page--dark .em-ana-card--critical {\n  background: rgba(239, 68, 68, 0.12);\n}\n\n/* Login layout */\n.em-login {\n  min-height: 100vh;\n  background:\n    radial-gradient(1200px 400px at 0% 0%, rgba(59, 130, 246, 0.10), transparent 60%),\n    radial-gradient(900px 360px at 100% 0%, rgba(16, 185, 129, 0.08), transparent 55%),\n    var(--em-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n}\n\n.em-login__shell {\n  width: 100%;\n  max-width: 1040px;\n  display: grid;\n  grid-template-columns: minmax(0, 3fr) minmax(0, 2.6fr);\n  gap: 24px;\n  background: #ffffff;\n  border-radius: 24px;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.10);\n  padding: 22px 22px 22px 26px;\n}\n\n.em-login__aside {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 20px;\n  color: var(--em-text);\n  border-right: 1px solid rgba(148, 163, 184, 0.3);\n  padding-right: 18px;\n}\n\n.em-login__logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.em-login__logoIcon {\n  width: 40px;\n  height: 40px;\n  border-radius: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(37, 99, 235, 0.18);\n  color: #60a5fa;\n}\n\n.em-login__logoText {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.em-login__logoTitle {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--em-text);\n}\n\n.em-login__logoSub {\n  font-size: 1.2rem;\n  color: var(--em-muted);\n}\n\n.em-login__hero h2 {\n  margin: 0 0 8px;\n  font-size: 2.1rem;\n  font-weight: 700;\n  color: var(--em-text);\n}\n\n.em-login__hero p {\n  margin: 0 0 14px;\n  font-size: 1.35rem;\n  color: var(--em-muted);\n}\n\n.em-login__heroMeta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  font-size: 1.2rem;\n  color: var(--em-text);\n}\n\n.em-login__heroMeta > div {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: rgba(59, 130, 246, 0.04);\n  border: 1px solid rgba(148, 163, 184, 0.4);\n}\n\n.em-login__card {\n  background: #ffffff;\n  border-radius: 18px;\n  padding: 20px 22px;\n  border: 1px solid rgba(148, 163, 184, 0.5);\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.12);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.em-login__cardHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.em-login__cardHeader .em-title {\n  color: var(--em-text);\n}\n\n.em-login__cardHeader .em-subtitle {\n  color: var(--em-muted);\n}\n\n@media (max-width: 900px) {\n  .em-login__shell {\n    grid-template-columns: minmax(0, 1fr);\n    padding: 20px 18px;\n  }\n  .em-login__aside {\n    border-right: none;\n    border-bottom: 1px solid rgba(148, 163, 184, 0.3);\n    padding-right: 0;\n    padding-bottom: 18px;\n  }\n}\n\n@media (max-width: 600px) {\n  .em-login {\n    padding: 16px 12px;\n  }\n}\n\n.em-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.em-title {\n  margin: 0;\n  color: var(--em-text);\n  /* letter-spacing: -0.02em; */\n}\n\n.em-subtitle {\n  margin: 4px 0 0;\n  color: var(--em-muted);\n  font-size: 1.4rem;\n}\n\n.em-grid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.em-card {\n  grid-column: span 3;\n  background: var(--em-card);\n  border: 1px solid var(--em-border);\n  border-radius: var(--em-radius);\n  box-shadow: var(--em-shadow-soft);\n  padding: 14px 14px;\n  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;\n}\n\n.em-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--em-shadow);\n  border-color: rgba(59, 130, 246, 0.20);\n}\n\n.em-card__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.em-card__label {\n  color: var(--em-muted);\n  font-size: 1.2rem;\n  text-transform: uppercase;\n  letter-spacing: .08em;\n}\n\n.em-card__value {\n  margin-top: 6px;\n  font-size: 2.4rem;\n  font-weight: 800;\n  color: var(--em-text);\n  letter-spacing: -0.02em;\n}\n\n.em-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(59, 130, 246, 0.12);\n  color: var(--em-primary);\n  flex: 0 0 auto;\n}\n\n.em-icon--danger {\n  background: rgba(239, 68, 68, 0.12);\n  color: var(--em-danger);\n}\n\n.em-icon--warning {\n  background: rgba(245, 158, 11, 0.12);\n  color: var(--em-warning);\n}\n\n.em-icon--success {\n  background: rgba(16, 185, 129, 0.12);\n  color: var(--em-success);\n}\n\n.em-panel {\n  background: var(--em-card);\n  border: 1px solid var(--em-border);\n  border-radius: var(--em-radius);\n  box-shadow: var(--em-shadow-soft);\n  padding: 14px;\n}\n\n/* Sticky toolbar (Error analysis + Live updates + Refresh) */\n.em-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 4;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  margin: 6px -6px 16px;\n  background: linear-gradient(to bottom, rgba(249, 250, 251, 0.96), rgba(249, 250, 251, 0.9));\n  backdrop-filter: blur(8px);\n  border-radius: 999px;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n}\n\n.em-toolbar__left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.em-toolbar__title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: var(--em-text);\n}\n\n.em-toolbar__badge {\n  font-size: 1.1rem;\n  padding: 3px 9px;\n  border-radius: 999px;\n  background: rgba(16, 185, 129, 0.08);\n  color: var(--em-success);\n  border: 1px solid rgba(16, 185, 129, 0.25);\n}\n\n.em-toolbar__right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.em-spinner {\n  width: 14px;\n  height: 14px;\n  border-radius: 999px;\n  border: 2px solid rgba(148, 163, 184, 0.5);\n  border-top-color: var(--em-primary);\n  animation: em-spin 0.8s linear infinite;\n}\n\n@keyframes em-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.em-filters {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;\n  gap: 10px;\n  align-items: end;\n}\n\n.em-field label {\n  display: block;\n  font-size: 1.2rem;\n  color: var(--em-muted);\n  margin-bottom: 6px;\n}\n\n.em-input {\n  width: 100%;\n  border: 1px solid var(--em-border);\n  border-radius: 12px;\n  padding: 10px 12px;\n  background: #fff;\n  outline: none;\n  transition: box-shadow .18s ease, border-color .18s ease;\n  min-height: 44px;\n}\n\n.em-input:focus {\n  border-color: rgba(59, 130, 246, 0.45);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);\n}\n\n/* Better-looking dropdowns */\n.em-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  padding-right: 40px;\n  cursor: pointer;\n  background-image:\n    linear-gradient(45deg, transparent 50%, rgba(100, 116, 139, 0.95) 50%),\n    linear-gradient(135deg, rgba(100, 116, 139, 0.95) 50%, transparent 50%),\n    linear-gradient(to right, transparent, transparent);\n  background-position:\n    calc(100% - 18px) 18px,\n    calc(100% - 13px) 18px,\n    0 0;\n  background-size: 6px 6px, 6px 6px, 100% 100%;\n  background-repeat: no-repeat;\n}\n\n.em-select:hover {\n  border-color: rgba(59, 130, 246, 0.30);\n}\n\n.em-select:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n  background-image: none;\n}\n\n.em-tableWrap {\n  background: var(--em-card);\n  border: 1px solid var(--em-border);\n  border-radius: var(--em-radius);\n  box-shadow: var(--em-shadow-soft);\n  overflow: hidden;\n}\n\n.em-tableScroll {\n  overflow-x: auto;\n  overflow-y: visible;\n}\n\n.em-tableScroll::-webkit-scrollbar {\n  height: 5px;\n  width: 0;\n  display: block;\n}\n\n.em-tableScroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.em-tableScroll::-webkit-scrollbar-thumb {\n  background: rgba(15, 23, 42, 0.1);\n  border-radius: 10px;\n}\n\n.em-tableScroll::-webkit-scrollbar-thumb:hover {\n  background: rgba(15, 23, 42, 0.2);\n}\n\n\n.em-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  min-width: 980px;\n}\n\n.em-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #fff;\n  border-bottom: 1px solid var(--em-border);\n  color: var(--em-muted);\n  font-size: 1.2rem;\n  letter-spacing: .08em;\n  text-transform: uppercase;\n  padding: 12px 14px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.em-table tbody td {\n  padding: 12px 14px;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.06);\n  vertical-align: middle;\n  color: var(--em-text);\n  font-size: 1.2rem;\n}\n\n.em-table tbody tr:nth-child(odd) td {\n  background: rgba(15, 23, 42, 0.015);\n}\n\n.em-table tbody tr:hover td {\n  background: rgba(59, 130, 246, 0.06);\n}\n\n.em-vendor {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n}\n\n.em-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-weight: 700;\n  font-size: 1.2rem;\n  letter-spacing: .02em;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.em-badge--high {\n  background: rgba(239, 68, 68, 0.12);\n  color: var(--em-danger);\n  border-color: rgba(239, 68, 68, 0.24);\n}\n\n.em-badge--medium {\n  background: rgba(245, 158, 11, 0.14);\n  color: var(--em-warning);\n  border-color: rgba(245, 158, 11, 0.26);\n}\n\n.em-badge--low {\n  background: rgba(16, 185, 129, 0.14);\n  color: var(--em-success);\n  border-color: rgba(16, 185, 129, 0.26);\n}\n\n.em-badge--status {\n  background: rgba(59, 130, 246, 0.10);\n  color: var(--em-primary);\n  border-color: rgba(59, 130, 246, 0.22);\n}\n\n.em-actions {\n  display: inline-flex;\n  /* gap: 8px;\n  flex-wrap: wrap; */\n}\n\n.em-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 999px;\n  padding: 7px 10px;\n  font-size: 1.2rem;\n  font-weight: 700;\n  border: 1px solid var(--em-border);\n  background: #fff;\n  color: var(--em-text);\n  cursor: pointer;\n  transition: transform .12s ease, background .12s ease, border-color .12s ease;\n}\n\n.em-btn:hover {\n  transform: translateY(-1px);\n  background: rgba(59, 130, 246, 0.06);\n  border-color: rgba(59, 130, 246, 0.30);\n}\n\n.em-btn--primary {\n  background: rgba(59, 130, 246, 0.12);\n  color: var(--em-primary);\n  border-color: rgba(59, 130, 246, 0.28);\n}\n\n.em-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n}\n\n.em-muted {\n  color: var(--em-muted);\n}\n\n.em-modalTitle {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.em-json {\n  font-family: var(--hw-font-monospace);\n  white-space: pre;\n}\n\n/* Markdown / answer rendering (ChatGPT-like) */\n.em-markdown {\n  font-size: 1.4rem;\n  line-height: 1.7;\n  color: var(--em-text);\n}\n\n.em-markdown h1,\n.em-markdown h2,\n.em-markdown h3,\n.em-markdown h4,\n.em-markdown h5,\n.em-markdown h6 {\n  margin: 1.2em 0 0.4em;\n  font-weight: 700;\n}\n\n.em-markdown p {\n  margin: 0.6em 0;\n}\n\n.em-markdown ul,\n.em-markdown ol {\n  margin: 0.6em 0 0.6em 1.6em;\n  padding-left: 1em;\n}\n\n.em-markdown li {\n  margin: 0.2em 0;\n}\n\n.em-markdown code {\n  font-family: var(--hw-font-monospace);\n  background: rgba(15, 23, 42, 0.04);\n  padding: 0.1em 0.35em;\n  border-radius: 4px;\n  font-size: 1.3rem;\n}\n\n.em-markdown pre code {\n  background: transparent;\n  padding: 0;\n}\n\n.em-markdown pre {\n  font-family: var(--hw-font-monospace);\n  background: #0f172a;\n  color: #e5e7eb;\n  padding: 1.2em 1.4em;\n  border-radius: 10px;\n  margin: 1em 0;\n  overflow-x: auto;\n  font-size: 1.3rem;\n}\n\n.em-markdown table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0.8em 0;\n  font-size: 1.3rem;\n}\n\n.em-markdown table th,\n.em-markdown table td {\n  border: 1px solid var(--em-border);\n  padding: 0.5em 0.75em;\n}\n\n.em-markdown table th {\n  background: rgba(15, 23, 42, 0.03);\n  text-align: left;\n  font-weight: 600;\n}\n\n/* Horizontal scroll indicator for mobile */\n.em-scrollHint {\n  display: none;\n  padding: 8px 14px;\n  font-size: 1.1rem;\n  color: var(--em-muted);\n  background: rgba(15, 23, 42, 0.02);\n  border-bottom: 1px solid var(--em-border);\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  font-weight: 500;\n}\n\n@media (max-width: 980px) {\n  .em-scrollHint {\n    display: flex;\n  }\n}\n\n@media (max-width: 1100px) {\n  .em-card {\n    grid-column: span 6;\n  }\n\n  .em-filters {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .em-card {\n    grid-column: span 12;\n  }\n\n  .em-page {\n    padding: 12px;\n  }\n}\n\n/* Error Analysis Section */\n.em-analysis {\n  margin: 32px 0;\n}\n\n.em-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid var(--em-border);\n}\n\n.em-analysis-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.em-ana-card {\n  background: var(--em-card);\n  border: 1px solid var(--em-border);\n  border-radius: 14px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  box-shadow: var(--em-shadow-soft);\n  transition: transform 0.2s ease;\n}\n\n.em-ana-card:hover {\n  transform: translateY(-2px);\n}\n\n.em-ana-card__icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.05);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.8rem;\n  color: var(--em-primary);\n  flex-shrink: 0;\n}\n\n.em-ana-card__info {\n  display: flex;\n  flex-direction: column;\n}\n\n.em-ana-card__label {\n  font-size: 1rem;\n  color: var(--em-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 600;\n}\n\n.em-ana-card__value {\n  font-size: 2.2rem;\n  font-weight: 800;\n  color: var(--em-text);\n  line-height: 1.2;\n}\n\n.em-ana-card--critical {\n  border-color: rgba(239, 68, 68, 0.2);\n  background: rgba(239, 68, 68, 0.02);\n}\n\n.em-ana-card--critical .em-ana-card__icon {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--em-danger);\n}\n\n.em-charts-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.em-chart-box {\n  background: var(--em-card);\n  border: 1px solid var(--em-border);\n  border-radius: var(--em-radius);\n  padding: 24px;\n  box-shadow: var(--em-shadow-soft);\n}\n\n.em-chart-box--full {\n  grid-column: span 2;\n}\n\n.em-chart-title {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--em-text);\n  margin-bottom: 24px;\n  letter-spacing: -0.01em;\n}\n\n.em-chart-container {\n  width: 100%;\n}\n\n@media (max-width: 1300px) {\n  .em-analysis-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 1100px) {\n  .em-charts-row {\n    grid-template-columns: 1fr;\n  }\n\n  .em-chart-box--full {\n    grid-column: span 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .em-analysis-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .em-analysis-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.em-markdown pre {\n  background: #0d1117;\n  padding: 16px;\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.em-markdown code {\n  font-size: 13px;\n}\n\n.em-markdown h3 {\n  margin-top: 24px;\n}\n\n.generated-fix-panel{\n  background: rgba(59, 130, 246, 0.12);\n  color: var(--em-primary);\n  border-color: rgba(59, 130, 246, 0.28);\n  margin-top: 10px;\n}\n.em-btn-active{\n  transform: translateY(-1px);\n  background: rgba(59, 130, 246, 0.06);\n  border-color: rgba(59, 130, 246, 0.30);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
